import { render, staticRenderFns } from "./CardActionMenu.vue?vue&type=template&id=0bc28722&scoped=true"
import script from "./CardActionMenu.vue?vue&type=script&lang=js"
export * from "./CardActionMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc28722",
  null
  
)

export default component.exports